import React from 'react';
import RegisterAndInvestForm from '../components/invest/RegisterAndInvestForm';
import InvestForm from '../components/invest/InvestForm';
import InvestmentList from '../components/invest/InvestmentList';
import { useContractState } from '../context/ContractContext';

export default function Invest() {
  const { userId, investments, loaded } = useContractState();
  if (!loaded) return <div className="page"><div className="card"><div className="spinner" style={{ margin: '30px auto' }} /></div></div>;
  return (
    <div className="page">
      <div className="page-title grad-text">{userId ? 'Invest' : 'Register & Invest'}</div>
      <p className="page-subtitle">Every stake mints Adrenaline NFTs to your collection.</p>
      <div className="section">{userId ? <InvestForm /> : <RegisterAndInvestForm />}</div>
      {userId > 0 && (
        <div className="section">
          <div className="section-header"><h2>Your Investments</h2></div>
          <InvestmentList investments={investments} />
        </div>
      )}
    </div>
  );
}
